<template>
  <v-main>
    <v-alert
      v-if="upcomingCollapsed"
      :type="upcomingAlertType"
      :icon="false"
      class="mb-0 rounded"
      outlined
      :color="upcomingAlertType === 'error' ? 'error' : 'primary'"
    >
      <h3 class="title" v-if="dueEntryClustered.length > 0">
        {{ $t("components.upcomingLogEntry.maintenanceDue") }}
      </h3>

      <h3 class="title" v-if="dueEntryClustered.length == 0">
        {{ $t("components.upcomingLogEntry.upcomingMaintenance") }}
      </h3>

      <div v-if="dueEntryClustered.length > 0">
        {{
          $tc(
            "components.upcomingLogEntry.haveOverdueMaintenanceTasks",
            dueEntryClustered.length
          )
        }}

        <span v-if="upcomingEntryClustered.length > 0">
          {{
            $tc(
              "components.upcomingLogEntry.requireMaintenanceSoon",
              upcomingEntryClustered.length
            )
          }}
        </span>
      </div>

      <div
        v-if="
          dueEntryClustered.length == 0 && upcomingEntryClustered.length > 0
        "
      >
        {{
          $tc(
            "components.upcomingLogEntry.requireMaintenanceSoon",
            upcomingEntryClustered.length
          )
        }}
      </div>

      <v-row class="mt-1">
        <v-col>
          <v-btn
            block
            class="button"
            :color="upcomingAlertType === 'error' ? 'error' : 'primary'"
            outlined
            @click="upcomingCollapsed = false"
          >
            {{ $t("components.upcomingLogEntry.showDetails") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-card :loading="loading" v-if="!upcomingCollapsed">
      <v-dialog v-model="showConfirmSaveDialog">
        <v-card>
          <v-card-title class="text-h5">{{
            $t("components.upcomingLogEntry.readyToSave")
          }}</v-card-title>

          <v-card-text>
            {{
              $t(
                "components.upcomingLogEntry.onceSavedYourEntryCannotBeModifiedOrDeleted"
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="darken-1" text @click="showConfirmSaveDialog = false">
              {{ $t("components.upcomingLogEntry.cancel") }}
            </v-btn>

            <v-btn color="red darken-1" text @click="saveAndResolve()">
              {{ $t("components.upcomingLogEntry.yesSave") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-list
        subheader
        three-line
        class="entry-list"
        style="border-radius: 20px;"
      >
        <v-subheader v-if="dueEntryClustered.length"
          >{{ $t("components.upcomingLogEntry.overdue") }}
        </v-subheader>
        <v-list-item-group
          v-model="selectedOverdueItemsIdxs"
          multiple
          active-class=""
        >
          <template
            :entry="entry"
            v-for="(entry, i) in dueEntryClustered"
            :value="entry.uuid"
          >
            <v-divider v-if="!entry" :key="`divider-${i}`"></v-divider>

            <v-list-item
              :key="`item-${i}`"
              active-class="blue--text text--accent-4"
            >
              <template v-slot:default="{ active }">
                <v-list-item-content>
                  <v-list-item-title
                    ><span v-if="entry.itemInstancesCount > 1"
                      >{{ entry.itemInstancesCount }}x </span
                    >{{ entry.itemName }}</v-list-item-title
                  >
                  <v-list-item-subtitle v-if="!showServiceDetails">{{
                    entry.dueAt
                  }}</v-list-item-subtitle>
                  <!-- <v-list-item-subtitle class="entry-tasks" v-if="!showServiceDetails">{{ entry.servicesTitle }}</v-list-item-subtitle> -->
                  <v-list-item-subtitle
                    class="entry-subtasks"
                    v-if="showServiceDetails"
                  >
                    <div
                      v-for="service in entry.dedupedServices"
                      :key="service.uuid"
                    >
                      <!-- <v-list-item-subtitle>{{service.title}}</v-list-item-subtitle> -->
                      <div>{{ service.dueAt }}</div>
                      <ul>
                        <li
                          v-for="subtask in service.subtasks"
                          :key="subtask.uuid"
                        >
                          {{ subtask.description }}
                        </li>
                      </ul>
                      <br />
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    color="blue accent-4"
                  ></v-checkbox>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
        <v-divider v-if="dueEntryClustered.length"></v-divider>
        <v-subheader v-if="upcomingEntryClustered.length">{{
          $t("components.upcomingLogEntry.upcoming")
        }}</v-subheader>

        <v-list-item
          v-for="(entry, i) in upcomingEntryClustered"
          :key="`item-${i}`"
        >
          <template>
            <v-list-item-content>
              <v-list-item-title>
                <!-- TODO TRANSLATIONS -->
                <span v-if="entry.itemInstancesCount > 1"
                  >{{ entry.itemInstancesCount }}x </span
                >{{ entry.itemName }}</v-list-item-title
              >
              <v-list-item-subtitle v-if="!showServiceDetails">{{
                entry.dueAt
              }}</v-list-item-subtitle>
              <!-- <v-list-item-subtitle class="entry-tasks" v-if="!showServiceDetails">{{ entry.servicesTitle }}</v-list-item-subtitle> -->
              <v-list-item-subtitle
                class="entry-subtasks"
                v-if="showServiceDetails"
              >
                <div
                  v-for="service in entry.dedupedServices"
                  :key="service.uuid"
                >
                  <!-- <v-list-item-subtitle>{{service.title}}</v-list-item-subtitle> -->
                  <div>{{ service.dueAt }}</div>
                  <ul>
                    <li v-for="subtask in service.subtasks" :key="subtask.uuid">
                      {{ subtask.description }}
                    </li>
                  </ul>
                  <br />
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list>

      <v-card-text class="subtext">
        {{
          $t(
            "components.upcomingLogEntry.maintenanceSchedulesAndServiceTasksAreProvidedByTheManufacturerAndServicePartnersTakesNoResponsibilityForInaccuracyOfSuchData",
            { brand: theme.entityName }
          )
        }}
      </v-card-text>

      <v-form :disabled="loading" v-if="resolving">
        <v-divider class="mb-2" />
        <v-container>
          <v-card flat tile>
            <v-card flat class="subheading"
              ><v-icon>mdi-wrench-outline</v-icon>
              {{
                $t(
                  "components.upcomingLogEntry.maintenanceWillBeMarkedAsResolved",
                  {
                    numSelectedItems: numSelectedItems,
                  }
                )
              }}
            </v-card>

            <v-file-input
              v-model="resolveAttachments"
              :label="$t('components.upcomingLogEntry.selectFiles')"
              clearable
              multiple
              show-size
              chips
              counter
              required
            ></v-file-input>
            <v-dialog
              ref="dateDialog"
              v-model="resolveDateDialog"
              :return-value.sync="resolveDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="resolveDate"
                  :label="$t('components.upcomingLogEntry.dateOfService')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="resolveDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">{{
                  $t("components.upcomingLogEntry.cancel")
                }}</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dateDialog.save(resolveDate)"
                  >{{ $t("components.upcomingLogEntry.ok") }}</v-btn
                >
              </v-date-picker>
            </v-dialog>
            <v-textarea color="primary" v-model="resolveNotes">
              <template v-slot:label>
                <div>
                  {{ $t("components.upcomingLogEntry.notes") }} <small></small>
                </div>
              </template>
            </v-textarea>
          </v-card>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="resolving = !resolving">{{
            $t("components.upcomingLogEntry.cancel")
          }}</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            text
            v-if="getDemoModeStatus"
            @click="handleOpenDemoModeDialog"
            >{{ $t("components.upcomingLogEntry.saveMarkAsDone") }}</v-btn
          >

          <v-btn text v-else @click.stop="showConfirmSaveDialog = true">{{
            $t("components.upcomingLogEntry.saveMarkAsDone")
          }}</v-btn>
        </v-card-actions>
      </v-form>

      <div v-if="!resolving">
        <v-card-actions>
          <!--  <span class="subheading">{{ numSelectedItems }} selected</span> -->
          <v-switch
            class="mt-0 details-switch ml-3"
            inset
            v-model="showServiceDetails"
          >
            <template v-slot:label>
              <v-btn plain :ripple="false" class="pl-0">{{
                $t("components.upcomingLogEntry.details")
              }}</v-btn>
            </template>
          </v-switch>
          <v-spacer></v-spacer>
          <v-btn
            v-if="getDemoModeStatus && dueEntryClustered.length > 0"
            text
            @click="handleOpenDemoModeDialog"
            :disabled="numSelectedItems == 0"
            class="pl-3"
            >{{ $t("components.upcomingLogEntry.markSelectedAsDone") }}</v-btn
          >
          <v-btn
            v-if="!getDemoModeStatus && dueEntryClustered.length > 0"
            text
            @click="resolving = true"
            :disabled="numSelectedItems == 0"
            class="pl-3"
            >{{ $t("components.upcomingLogEntry.markSelectedAsDone") }}</v-btn
          >
        </v-card-actions>
      </div>
    </v-card>
  </v-main>
</template>

<script>
// import EntryNote from "@/components/EntryNote.vue";
import { mapState, mapGetters } from "vuex";
import { updateLogEntry } from "@/api/log-entries";
import {
  uploadNoteAttachment,
  uploadResolvingNoteAttachment,
  createResolvingLogNote,
  updateEntryStatus,
  loadEntry,
  createLogEntryFromServiceItems,
  uploadFileResources,
} from "@/api/log-entries";

export default {
  name: "log-entry",
  components: {},
  props: {
    dueEntryClustered: Array,
    upcomingEntryClustered: Array,
  },
  data: () => ({
    upcomingCollapsed: true,
    showConfirmSaveDialog: false,
    selectedUpcomingItemsIdxs: [],
    selectedOverdueItemsIdxs: [],
    loading: false,
    expanded: false,
    resolving: false,
    resolveAttachments: [],
    resolveNotes: "",
    resolveDate: null,
    showingRequestAssistanceDialog: false,
    resolveDateDialog: false,
    showServiceDetails: false,
  }),
  created() {
    this.resolveDate = (this && this.entry && this.entry.completion_date
      ? new Date(this.entry.completion_date)
      : new Date()
    )
      .toISOString()
      .split("T")[0];
  },
  computed: {
    ...mapState({
      accessToken: (s) => s.accessToken,
      userBoatId: (s) => s.userBoatId,
      theme: (s) => s.theme,
    }),

    ...mapGetters(["getDemoModeStatus"]),

    resolveCompletionDate: function() {
      return new Date(Date.parse(this.resolveDate));
    },
    numSelectedItems: function() {
      return this.selectedItems.map((x) => x.services.map((s) => s.uuid)).flat()
        .length;

      // return (
      //   this.selectedUpcomingItemsIdxs.length +
      //   this.selectedOverdueItemsIdxs.length
      // );
    },
    selectedOverdueItems: function() {
      return this.selectedOverdueItemsIdxs.map((idx) => {
        return this.dueEntryClustered[idx];
      });
    },
    selectedUpcomingItems: function() {
      return this.selectedUpcomingItemsIdxs.map((idx) => {
        return this.upcomingEntryClustered[idx];
      });
    },
    selectedItems: function() {
      return this.selectedUpcomingItems.concat(this.selectedOverdueItems);
    },
    upcomingAlertType: function() {
      if (this.dueEntryClustered.length > 0) {
        return "error";
      } else {
        return "info";
      }
    },
  },
  watch: {
    selectedItems(newSelection) {
      let message = newSelection
        .map((x) => {
          let count = x.itemInstancesCount;
          if (count === 1) {
            return `${x.itemName}`;
          } else {
            return `${count}x ${x.itemName}`;
          }
        })
        .join("\n");

      message = this.$t("components.upcomingLogEntry.servicedTheFollowing", {
        message: message,
      });

      this.resolveNotes = message;
    },
  },
  methods: {
    handleOpenDemoModeDialog() {
      this.$store.commit("setDemoModeDialogStatus", true);
    },
    saveAndResolve: function() {
      if (this.numSelectedItems == 0) {
        return;
      }

      // unfurl selectedItems into the list of all service events
      let selectedServices = this.selectedItems
        .map((x) => x.services.map((s) => s.uuid))
        .flat();

      this.loading = true;

      // TODO: API does not yet support file_resource_uuids
      uploadFileResources(
        this.accessToken,
        this.resolveAttachments,
        this.userBoatId
      )
        .then((fileResources) => {
          return fileResources.map((x) => x.file_resource_uuid);
        })
        .then((fileResourceUUIDs) => {
          let note = {
            comment: this.resolveNotes,
            completion_date: this.resolveCompletionDate,
            service_report_uuids: selectedServices,
            attachment_uuids: fileResourceUUIDs,
          };

          return createLogEntryFromServiceItems(
            this.accessToken,
            this.userBoatId,
            note
          );
        })
        .then((status) => {
          this.loading = false;
          this.$emit("reloadAll", true);
        });
    },
  },
};
</script>

<style scoped>
.attachment {
  width: 100px;
  height: 150px;
}
</style>

<style lang="scss">
/* Hacks for showing "DETAILS" switch with less extra whitespace*/
.details-switch {
  &.v-input--selection-controls {
    padding-top: 0;
  }

  .v-messages {
    display: none;
  }

  .v-input__slot {
    margin-bottom: 0;
  }
}
.entry-subtasks {
  &.v-list-item__subtitle {
    white-space: normal;
  }
}

/* HACK remove clamping to 2 lines cause by list three-line, which
I use to keep the checkbox at the top (three-line set it on center)*/
.v-list--three-line .v-list-item .entry-subtasks.v-list-item__subtitle,
.v-list--three-line .v-list-item .entry-tasks.v-list-item__subtitle {
  line-clamp: inherit;
  -webkit-line-clamp: inherit;
}

.entry-list.v-list--three-line .v-list-item {
  min-height: auto;
}

.subtext {
  color: #969696;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
</style>
